var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"UserProfileView"},[_c('span',{staticClass:"UserProfileView__name UserProfileView__name_pre"},[_vm._v(" Logged in as ")]),_c('span',{staticClass:"UserProfileView__name UserProfileView__name_text"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }